import React, { useCallback, useEffect, useRef } from 'react';
import classNames from 'classnames';
import "./CardFlip.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Card flip component, switches between a front and back face being visible.
 * Has logic to handle overflow on body, caused by perspective transforms
 * and moves z-index to top during transition.
 * @param isFlipped true shows second child, false shows first child
 * @param children Expects exactly two children
 * @returns
 */
function CardFlip(_ref) {
  var className = _ref.className,
    isFlipped = _ref.isFlipped,
    children = _ref.children,
    dataTestId = _ref['data-testid'];
  var getComponent = key => {
    if (children.length !== 2) {
      throw new Error('CardFlip requires 2 children to function');
    }
    return children[key];
  };
  var front = useRef(null);
  var transitionStart = useCallback(event => {
    if (event.target === event.currentTarget) {
      document.body.classList.add('card-flip--is-flipping');
    }
  }, []);
  var transitionEnd = useCallback(event => {
    if (event.target === event.currentTarget) {
      document.body.classList.remove('card-flip--is-flipping');
    }
  }, []);
  useEffect(function setIsFlippingClassOnTransitionStart() {
    if (!front.current) throw Error('ref undefined');
    front.current.addEventListener('transitionstart', transitionStart);
    var refObj = front.current;
    return function cleanupListener() {
      if (refObj != null) {
        return refObj.removeEventListener('transitionstart', transitionStart);
      }
    };
  }, [transitionStart]);
  return /*#__PURE__*/_jsxs("div", {
    className: classNames(className, {
      'card-flip--show-front': isFlipped,
      'card-flip--show-back': !isFlipped
    }),
    "data-testid": dataTestId,
    children: [/*#__PURE__*/_jsx("div", {
      className: "card-flip--back",
      children: getComponent(0)
    }), /*#__PURE__*/_jsx("div", {
      ref: front,
      className: "card-flip--front",
      onTransitionEnd: transitionEnd,
      children: getComponent(1)
    })]
  });
}
export default CardFlip;
//# sourceMappingURL=CardFlip.js.map